import { Award, Diamond, Gem, Medal, Crown } from "lucide-react";

const PACKAGES = [
  { name: "Bronze", color: "#d49a6a", Icon: Medal },
  { name: "Silver", color: "#cbd5e1", Icon: Award },
  { name: "Gold", color: "#f4c95d", Icon: Crown },
  { name: "Platinum", color: "#a5d9dd", Icon: Gem },
  { name: "Diamond", color: "#8acbff", Icon: Diamond },
];

export function getRequiredPackage(availablePackages, currentPackage) {
  const available = String(availablePackages || "").split(",").map(name => name.trim().toLowerCase());
  const currentIndex = PACKAGES.findIndex(pack => pack.name.toLowerCase() === String(currentPackage || "").trim().toLowerCase());
  return PACKAGES.find((pack, index) => index > currentIndex && available.includes(pack.name.toLowerCase()))
    || PACKAGES.find(pack => available.includes(pack.name.toLowerCase()))
    || { name: "", color: "#cbd5e1", Icon: Gem };
}
